<template>
  <PrivacySection title="1. Introduzione">
    <p>
      ISIGest S.r.l., titolare dell'applicazione <strong>App degli Scontrini</strong>,
      mette a disposizione questa pagina per consentire agli utenti di esercitare il
      diritto alla cancellazione dei propri dati personali, in conformità con:
    </p>
    <ul>
      <li>Regolamento (UE) 2016/679 (GDPR)</li>
      <li>Requisiti di Google Play Store per la cancellazione dei dati degli utenti</li>
      <li>Requisiti di Apple App Store per la cancellazione dell'account e dei dati</li>
    </ul>
    <p>
      Questa pagina descrive quali dati vengono eliminati, quali possono essere
      conservati e come procedere con la richiesta di cancellazione.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'

export default {
  name: 'IntroductionSection',
  components: {
    PrivacySection
  }
}
</script>
